import config from './config'
import { routerReducer } from 'react-router-redux'
import fieldsReducer from '../common/modules/fields/fields-reducer'
import errorsReducer from '../common/modules/errors/errors-reducer'
import productDataReducer from '../common/modules/product-data/product-data-reducer'
import statusReducer from '../common/modules/status/status-reducer'
import formReducer from '../common/modules/form/form-reducer'
import cobrandReducer from '../common/modules/cobrand/cobrand-reducer'
import navigationReducer from '../common/modules/navigation/navigation-reducer'
import configReducer from '../common/modules/config/config-reducer'
import progressReducer from '../common/modules/progress/progress-reducer'
import validationReducer from '../common/modules/validation/validation-reducer'
import submissionReducer from '../common/modules/submission/submission-reducer'
import suburbAutoCompleteReducer from '../common/modules/suburb-auto-complete/suburb-auto-complete-reducer'
import addressValidationReducer from '../common/modules/address-validation/address-validation-reducer'
import restoreReducer from '../common/modules/restore/restore-reducer'
import quoteSupportReducer from '../common/modules/quote-support/quote-support-reducer'
import postcodeAutoCompleteReducer from '../common/modules/postcode-auto-complete/postcode-auto-complete-reducer'


export default {
    routing: routerReducer,
    fields: fieldsReducer({}),
    errors: errorsReducer({}),
    addressValidation: addressValidationReducer(config),
    productData: productDataReducer(config),
    status: statusReducer(),
    form: formReducer(),
    submission: submissionReducer(config),
    restore: restoreReducer(config),
    cobrand: cobrandReducer(),
    navigation: navigationReducer(),
    progress: progressReducer(config),
    validation: validationReducer(),
    suburbAutoComplete: suburbAutoCompleteReducer(config),
    postcodeAutoComplete: postcodeAutoCompleteReducer(config),
    quoteSupport: quoteSupportReducer(config),
    config: configReducer(config),
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/strata/reducer-map.ts